import { type PayloadAction, createSlice } from "@reduxjs/toolkit";
import type {
    AvailableGradesForConfigurableType,
    CarConfigAvailableInOtherGradesType,
} from "../../../../shared-logic/types/AvailableInOtherGradesType";

export const initialState: CarConfigAvailableInOtherGradesType = {
    initialized: false,
    disabled: true, // In reality this is the exact same variable as "disableAvailableInOtherGrades" in carConfigSettings. This is just an extra state variable to make it more clear when this is disabled.
    availableMotorizations: [],
    availableColours: [],
    availableUpholsteries: [],
    availableWheels: [],
    availableGradesForConfigurable: { fetching: false, error: false, grades: [] },
};

export type CarConfigAvailableInOtherGradesTypes = ReturnType<
    | typeof initAvailableInOtherGrades
    | typeof startAvailableGradesForConfigurableFetch
    | typeof finishAvailableGradesForConfigurableFetch
    | typeof selectGradeForConfigurable
>;

export const CarConfigAvailableInOtherGradesSlice = createSlice({
    name: "availableInOtherGrades",
    initialState,

    reducers: {
        initAvailableInOtherGrades(state, action: PayloadAction<CarConfigAvailableInOtherGradesType>) {
            return { ...state, ...action.payload, disabled: false, initialized: true };
        },
        startAvailableGradesForConfigurableFetch(
            state,
            action: PayloadAction<{
                configurationObjectType: "car" | "colour" | "upholstery" | "wheel";
                configurationObjectId: string;
            }>,
        ) {
            return {
                ...state,
                ...action.payload,
                availableGradesForConfigurable: { error: false, fetching: true, grades: [] },
            };
        },
        finishAvailableGradesForConfigurableFetch(
            state,
            action: PayloadAction<{ availableGradesForConfigurable: AvailableGradesForConfigurableType }>,
        ) {
            return { ...state, ...action.payload };
        },
        selectGradeForConfigurable(
            state,
            action: PayloadAction<{ availableGradesForConfigurable: AvailableGradesForConfigurableType }>,
        ) {
            return { ...state, ...action.payload };
        },
    },
});

export const {
    initAvailableInOtherGrades,
    startAvailableGradesForConfigurableFetch,
    finishAvailableGradesForConfigurableFetch,
    selectGradeForConfigurable,
} = CarConfigAvailableInOtherGradesSlice.actions;
